const API_BASE = 'https://api.dev.auxo.dk';

export async function fetchCMS(endpoint) {
  try {
    const response = await fetch(`${API_BASE}${endpoint}`);
    if (!response.ok) {
      throw new Error(`CMS fetch failed: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching from CMS:', error);
    return null;
  }
}

export async function fetchPages() {
  return await fetchCMS('/public/content/sider') || [];
}

export async function fetchPageBySlug(slug) {
  return await fetchCMS(`/public/by-slug/da/${slug}`);
}

export async function fetchTeaching() {
  return await fetchCMS('/public/content/undervisning') || [];
}

export async function fetchEvents() {
  return await fetchCMS('/public/content/arrangementer') || [];
}

export async function fetchMusic() {
  const data = await fetchCMS('/public/content/musik') || [];
  const order = {
    'breaking-through-the-firewall': 1,
    'talisman': 2,
    'audioballerina': 3,
  };
  return [...data].sort((a, b) => {
    const orderA = order[a.slug?.da] || 99;
    const orderB = order[b.slug?.da] || 99;
    return orderA - orderB;
  });
}

export async function fetchGalleries() {
  return await fetchCMS('/public/content/galleri') || [];
}

export async function fetchReviews() {
  return await fetchCMS('/public/content/anmeldelser') || [];
}

export async function fetchNoticeboard() {
  return await fetchCMS('/public/content/opslagstavle') || [];
}

export async function fetchBlogPosts(params = '') {
  return await fetchCMS(`/public/v2/content/blog${params ? `?${params}` : ''}`) || { items: [], total: 0 };
}

export async function fetchBlogPostBySlug(slug) {
  return await fetchCMS(`/public/by-slug/da/${slug}`);
}

export async function fetchTaxonomyTerms(taxonomy = 'kategori') {
  return await fetchCMS(`/public/taxonomies/${taxonomy}/terms`) || [];
}
